import script from "./CaseConferenceLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./CaseConferenceLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__